/* CONTRABAND experience shell: grain, cursor, reveals, countdown, draggable evidence,
   board flashlight, inspection room. Loads site-wide; each module guards on element presence. */
(function(){
  'use strict';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var AC = null, soundOn = false; /* SFX off by default — music/sound removed 2026-08-01 */

  /* ---------- toast ---------- */
  var toastEl = null, toastTimer = null;
  function toast(msg){
    if (!toastEl){
      toastEl = document.createElement('div');
      toastEl.className = 'cbx-toast';
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function(){ toastEl.classList.remove('show'); }, 2800);
  }

  /* ---------- blips ---------- */
  function blip(freq, dur, vol, type){
    if (!soundOn) return;
    try{
      AC = AC || new (window.AudioContext || window.webkitAudioContext)();
      var o = AC.createOscillator(), g = AC.createGain();
      o.type = type || 'square'; o.frequency.value = freq;
      g.gain.setValueAtTime(vol || .1, AC.currentTime);
      g.gain.exponentialRampToValueAtTime(.0001, AC.currentTime + (dur || .08));
      o.connect(g); g.connect(AC.destination);
      o.start(); o.stop(AC.currentTime + (dur || .08) + .02);
    }catch(_){}
  }

  /* ---------- grain + vignette + cursor ring ---------- */
  var grain = document.createElement('canvas');
  grain.id = 'cbxGrain';
  document.body.appendChild(grain);
  var vig = document.createElement('div');
  vig.className = 'cbx-vignette';
  document.body.appendChild(vig);
  var gctx = grain.getContext('2d');
  function sizeGrain(){ grain.width = Math.floor(innerWidth/3); grain.height = Math.floor(innerHeight/3); }
  sizeGrain(); addEventListener('resize', sizeGrain);
  function drawGrain(){
    var d = gctx.createImageData(grain.width, grain.height), b = d.data;
    for (var i = 0; i < b.length; i += 4){
      var v = (Math.random()*255)|0;
      b[i]=v; b[i+1]=v; b[i+2]=v; b[i+3]=20;
    }
    gctx.putImageData(d, 0, 0);
  }
  drawGrain();
  if (!reduced) setInterval(drawGrain, 120);

  if (matchMedia('(pointer:fine)').matches && !reduced){
    var ring = document.createElement('div');
    ring.className = 'cbx-ring';
    document.body.appendChild(ring);
    var cx=-100, cy=-100, rx=-100, ry=-100;
    addEventListener('mousemove', function(e){
      cx = e.clientX; cy = e.clientY;
      ring.classList.add('on');
      var hit = e.target.closest && e.target.closest('a,button,select,input,.cbx-photo,.cbx-pinned');
      ring.classList.toggle('grow', !!hit);
    });
    (function loop(){
      rx += (cx-rx)*.2; ry += (cy-ry)*.2;
      ring.style.left = rx+'px'; ring.style.top = ry+'px';
      requestAnimationFrame(loop);
    })();
  }

  /* ---------- reveals ---------- */
  var revealEls = document.querySelectorAll('.cbx-reveal');
  if (revealEls.length){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if (e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } });
    }, {threshold:.12});
    revealEls.forEach(function(el){ io.observe(el); });
  }

  /* ---------- countdown ---------- */
  var cdStrip = document.querySelector('[data-cbx-count]');
  if (cdStrip){
    var dropAt = new Date(cdStrip.getAttribute('data-cbx-count')).getTime();
    var cdEls = {
      d: cdStrip.querySelector('[data-cd="d"]'),
      h: cdStrip.querySelector('[data-cd="h"]'),
      m: cdStrip.querySelector('[data-cd="m"]'),
      s: cdStrip.querySelector('[data-cd="s"]')
    };
    var pad = function(n){ return n<10 ? '0'+n : ''+n; };
    var liveMode = false;
    function goLive(){
      if (liveMode) return;
      liveMode = true;
      cdStrip.classList.add('cbx-live');
      cdStrip.innerHTML = '<span class="cbx-livemsg">● THE DROP IS LIVE — <a href="/collections/latest-drop">SHOP IT BEFORE IT\'S GONE</a></span>';
      var hub = document.querySelector('[data-cbx-hub]');
      if (hub){
        var qq = hub.querySelector('.cbx-q'); if (qq) qq.textContent = '!';
        var cap = hub.querySelector('.cbx-pcap'); if (cap) cap.textContent = 'THE DROP IS LIVE';
      }
      var mq = document.querySelector('.cbx-marquee-track');
      if (mq) mq.innerHTML = '<span>THE DROP IS LIVE</span><span class="hollow">RIGHT NOW</span>' + mq.innerHTML;
    }
    var tick = function(){
      var now = Date.now(), left = dropAt - now;
      /* within 48h after the target: LIVE mode takes over the strip, board, marquee */
      if (left <= 0 && now - dropAt < 48*3600*1000){ goLive(); return; }
      while (left < 0){ dropAt += 7*24*3600*1000; left = dropAt - now; }
      var s = Math.floor(left/1000);
      cdEls.d.textContent = pad(Math.floor(s/86400));
      cdEls.h.textContent = pad(Math.floor(s%86400/3600));
      cdEls.m.textContent = pad(Math.floor(s%3600/60));
      cdEls.s.textContent = pad(s%60);
    };
    if (!isNaN(dropAt)){ tick(); setInterval(tick, 1000); }
  }

  /* ---------- draggable engine (toss physics) ---------- */
  function makeDraggable(container, items, opts){
    opts = opts || {};
    items.forEach(function(item){
      var st = { vx:0, vy:0, lastX:0, lastY:0, lastT:0, raf:null, baseRot:+(item.getAttribute('data-rot')||0), tilt:0 };
      item._st = st;
      function setPos(x, y){
        x = Math.max(0, Math.min(container.clientWidth - item.offsetWidth, x));
        y = Math.max(opts.minY||0, Math.min(container.clientHeight - item.offsetHeight, y));
        item.style.left = x+'px'; item.style.top = y+'px';
        if (opts.onMove) opts.onMove();
      }
      var drag = null, moved = false;
      item.addEventListener('pointerdown', function(e){
        if (st.raf){ cancelAnimationFrame(st.raf); st.raf = null; }
        item.style.right = 'auto'; item.style.bottom = 'auto';
        item.setAttribute('data-grabbed','1');
        drag = { sx:e.clientX, sy:e.clientY, ox:item.offsetLeft, oy:item.offsetTop };
        moved = false; st.vx = 0; st.vy = 0;
        st.lastX = e.clientX; st.lastY = e.clientY; st.lastT = performance.now();
        item.classList.add('drag');
        blip(170, .05, .06);
        try{ item.setPointerCapture(e.pointerId); }catch(_){}
        e.preventDefault();
      });
      item.addEventListener('pointermove', function(e){
        if (!drag) return;
        var now = performance.now(), dt = Math.max(8, now - st.lastT);
        st.vx = (e.clientX - st.lastX)/dt*16; st.vy = (e.clientY - st.lastY)/dt*16;
        st.lastX = e.clientX; st.lastY = e.clientY; st.lastT = now;
        var dx = e.clientX - drag.sx, dy = e.clientY - drag.sy;
        if (Math.abs(dx)+Math.abs(dy) > 7) moved = true;
        st.tilt = Math.max(-14, Math.min(14, st.vx*1.4));
        item.style.transform = 'rotate('+(st.baseRot + st.tilt)+'deg)';
        setPos(drag.ox + dx, drag.oy + dy);
      });
      function release(){
        if (!drag) return;
        item.classList.remove('drag');
        var tapped = !moved;
        drag = null;
        if (tapped){ if (opts.onTap) opts.onTap(item); return; }
        blip(80, .1, .1, 'sine');
        (function fling(){
          st.vx *= .90; st.vy *= .90; st.tilt *= .85;
          var nx = item.offsetLeft + st.vx, ny = item.offsetTop + st.vy;
          if (nx <= 0 || nx >= container.clientWidth - item.offsetWidth){ st.vx = -st.vx*.45; nx = item.offsetLeft + st.vx; }
          if (ny <= (opts.minY||0) || ny >= container.clientHeight - item.offsetHeight){ st.vy = -st.vy*.45; ny = item.offsetTop + st.vy; }
          item.style.transform = 'rotate('+(st.baseRot + st.tilt)+'deg)';
          setPos(nx, ny);
          if (Math.abs(st.vx) > .4 || Math.abs(st.vy) > .4 || Math.abs(st.tilt) > .5){
            st.raf = requestAnimationFrame(fling);
          } else {
            st.raf = null;
            item.style.transform = 'rotate('+st.baseRot+'deg)';
          }
        })();
      }
      item.addEventListener('pointerup', release);
      item.addEventListener('pointercancel', function(){
        /* browser took over (scroll) — drop the drag, never treat as a tap */
        if (!drag) return;
        item.classList.remove('drag');
        drag = null;
      });
    });
  }

  /* ---------- hero: parallax + spotlight + draggable photos ---------- */
  var hero = document.querySelector('[data-cbx-hero]');
  if (hero){
    var evd = hero.querySelector('[data-cbx-evidence]');
    var photos = evd ? Array.prototype.slice.call(evd.querySelectorAll('.cbx-photo')) : [];
    if (!reduced && matchMedia('(pointer:fine)').matches){
      hero.addEventListener('mousemove', function(e){
        var r = hero.getBoundingClientRect();
        hero.style.setProperty('--hx', (e.clientX - r.left) + 'px');
        hero.style.setProperty('--hy', (e.clientY - r.top) + 'px');
        var x = (e.clientX - r.left)/r.width - .5, y = (e.clientY - r.top)/r.height - .5;
        photos.forEach(function(p){
          if (p.getAttribute('data-grabbed')) return;
          var d = +p.getAttribute('data-depth') || 20;
          p.style.transform = 'rotate('+p.getAttribute('data-rot')+'deg) translate('+(-x*d)+'px,'+(-y*d)+'px)';
        });
      });
    }
    /* hero photos are only draggable with a mouse — on phones they are a fixed row */
    if (evd && photos.length && matchMedia('(pointer:fine)').matches) makeDraggable(evd, photos, {});
  }

  /* ---------- evidence board ---------- */
  var board = document.querySelector('[data-cbx-board]');
  if (board){
    var strings = board.querySelector('[data-cbx-strings]');
    var pinned = Array.prototype.slice.call(board.querySelectorAll('.cbx-pinned'));
    pinned.forEach(function(el){ el.style.transform = 'rotate(' + el.getAttribute('data-rot') + 'deg)'; });
    function pinPoint(el){ return { x: el.offsetLeft + el.offsetWidth/2, y: el.offsetTop + 2 }; }
    function drawStrings(){
      var hub = board.querySelector('[data-cbx-hub]');
      if (!hub || !strings) return;
      var hp = pinPoint(hub), d = '';
      pinned.forEach(function(el){
        if (el === hub) return;
        var a = pinPoint(el);
        var mx = (a.x+hp.x)/2, my = Math.max(a.y,hp.y) + 42;
        d += 'M'+a.x+' '+a.y+' Q'+mx+' '+my+' '+hp.x+' '+hp.y+' ';
      });
      strings.innerHTML = '<path d="'+d+'" fill="none" stroke="#d92b23" stroke-width="2" opacity=".8"/>';
    }
    drawStrings();
    addEventListener('resize', drawStrings);
    addEventListener('load', drawStrings);
    makeDraggable(board, pinned, {
      minY: 8,
      onMove: drawStrings,
      onTap: function(item){
        var url = item.getAttribute('data-url');
        if (!url){ toast('CLASSIFIED — CHECK THE COUNTDOWN'); return; }
        var m = url.match(/\/products\/([a-z0-9\-]+)/i);
        if (m && window.CBX && window.CBX.openCaseFile) window.CBX.openCaseFile(m[1]);
        else window.location.href = url;
      }
    });
    var homes = [];
    function recordHomes(){ homes = pinned.map(function(el){ return {el:el, x:el.offsetLeft, y:el.offsetTop}; }); }
    addEventListener('load', recordHomes);
    recordHomes();
    var btnRefile = document.querySelector('[data-cbx-refile]');
    if (btnRefile) btnRefile.addEventListener('click', function(){
      blip(240, .06, .08);
      homes.forEach(function(h){
        var st = h.el._st;
        if (st && st.raf){ cancelAnimationFrame(st.raf); st.raf = null; }
        h.el.style.transition = 'left .55s cubic-bezier(.2,1.2,.4,1), top .55s cubic-bezier(.2,1.2,.4,1)';
        h.el.style.left = h.x+'px'; h.el.style.top = h.y+'px';
        h.el.style.transform = 'rotate('+h.el.getAttribute('data-rot')+'deg)';
      });
      var iv = setInterval(drawStrings, 30);
      setTimeout(function(){
        clearInterval(iv); drawStrings();
        homes.forEach(function(h){ h.el.style.transition = ''; });
      }, 620);
    });
    var lightsOut = false;
    var btnLights = document.querySelector('[data-cbx-lights]');
    var darkLayer = board.querySelector('[data-cbx-dark]');
    var scribLayer = board.querySelector('[data-cbx-scrib]');
    if (btnLights) btnLights.addEventListener('click', function(){
      lightsOut = !lightsOut;
      board.classList.toggle('lights-out', lightsOut);
      btnLights.textContent = lightsOut ? 'LIGHTS ON' : 'CUT THE LIGHTS';
      btnLights.classList.toggle('on', lightsOut);
      blip(lightsOut ? 110 : 520, .09, .09, 'sine');
      if (lightsOut) toast('SWEEP THE BOARD WITH YOUR LIGHT — YOU CAN STILL DRAG IN THE DARK');
    });
    board.addEventListener('pointermove', function(e){
      if (!lightsOut) return;
      var r = board.getBoundingClientRect(), x = e.clientX - r.left, y = e.clientY - r.top;
      var hole = 'radial-gradient(circle 175px at '+x+'px '+y+'px, transparent 0 110px, #000 175px)';
      var show = 'radial-gradient(circle 175px at '+x+'px '+y+'px, #000 0 110px, transparent 175px)';
      if (darkLayer){ darkLayer.style.webkitMaskImage = hole; darkLayer.style.maskImage = hole; }
      if (scribLayer){ scribLayer.style.webkitMaskImage = show; scribLayer.style.maskImage = show; }
    });
    var btnSnd = document.querySelector('[data-cbx-soundtoggle]');
    if (btnSnd) btnSnd.addEventListener('click', function(){
      soundOn = !soundOn;
      btnSnd.textContent = 'SOUND: ' + (soundOn ? 'ON' : 'OFF');
      if (soundOn) blip(520, .07, .09, 'sine');
    });
  }

  /* ---------- inspection room ---------- */
  var uv = document.querySelector('[data-cbx-uv]');
  if (uv){
    var uvHidden = uv.querySelector('[data-cbx-uvhidden]');
    var uvGlow = uv.querySelector('[data-cbx-uvglow]');
    function uvSweep(e){
      var r = uv.getBoundingClientRect(), x = e.clientX - r.left, y = e.clientY - r.top;
      if (uvHidden){
        var hr = uvHidden.getBoundingClientRect();
        uvHidden.style.setProperty('--ux', x + 'px');
        uvHidden.style.setProperty('--uy', (e.clientY - hr.top) + 'px');
      }
      if (uvGlow) uvGlow.style.background = 'radial-gradient(circle 220px at '+x+'px '+y+'px, rgba(217,43,35,.14), transparent 70%)';
    }
    uv.addEventListener('pointermove', uvSweep);
    uv.addEventListener('pointerdown', uvSweep);
    var chip = uv.querySelector('[data-cbx-code]');
    if (chip) chip.addEventListener('click', function(){
      var code = chip.getAttribute('data-cbx-code');
      if (navigator.clipboard && navigator.clipboard.writeText){
        navigator.clipboard.writeText(code).then(
          function(){ toast('CODE COPIED — '+code+' · 10% OFF AT CHECKOUT'); },
          function(){ toast('CODE: '+code); }
        );
      } else toast('CODE: '+code);
    });
  }

  /* ---------- stats count-up ---------- */
  var statNums = document.querySelectorAll('[data-cbx-statnum]');
  if (statNums.length){
    var statIO = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if (!en.isIntersecting) return;
        statIO.unobserve(en.target);
        var target = +en.target.getAttribute('data-count'), t0 = null;
        if (reduced){ en.target.textContent = target; return; }
        function step(ts){
          if (!t0) t0 = ts;
          var p = Math.min(1, (ts-t0)/1200);
          en.target.textContent = Math.round(target * p * (2-p));
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    }, {threshold:.4});
    statNums.forEach(function(n){ statIO.observe(n); });
  }

  /* ---------- redacted reveal ---------- */
  var red1 = document.querySelector('[data-cbx-redact]');
  if (red1){
    red1.addEventListener('click', function(){ red1.classList.toggle('open'); });
    red1.addEventListener('keydown', function(e){
      if (e.key === 'Enter' || e.key === ' '){ e.preventDefault(); red1.classList.toggle('open'); }
    });
  }
})();
